import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';

/**
 * @tags document
 * @name FundDocumentExtractedClauseGET
 * @summary Get extracted clauses from a document.
 * @param docId The document ID.
 * @request GET:/document/{docId}/extracted-clause
 * */
export const endpointDocumentClauseGET = async (docId: string) => {
  return await documentClauseExec<'GET'>({
    method: 'GET',
    urlExtra: `/${docId}/extracted-clause`,
  });
};

export const endpointDocumentClauseDELETE = async (
  docId: string,
  fieldId: string,
) => {
  return await documentClauseExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${docId}/extracted-clause/${fieldId}`,
  });
};

interface DocumentClauseEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GetDocumentClauseResponse;
    };
    DELETE: {
      response: DeleteExtractedClauseResponse;
    };
  };
}

type DeleteExtractedClauseResponse = BqResponse<{
  data: object;
}>;

export type GetDocumentClauseResponse = BqResponse<{
  data: DocumentClauseAPIModel[];
}>;

const documentClauseExec =
  getExecEndpoint<DocumentClauseEndpointDef>(documentEndpoint);

export type DocumentClauseAPIModel = {
  id: string;
  name: string;
  summary: string;
  fullText: string;
  startXCoordinate: number;
  endXCoordinate: number;
  startYCoordinate: number;
  endYCoordinate: number;
  startPageNo: number;
  endPageNo: number;
};
